export default __webpack_public_path__ + "static/media/YAS0340.34I-29791_-17229_0.818de867.jpg";